import { c as _c } from "react/compiler-runtime";
import { SectionMessage } from 'shared/components/section-message';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { GrowthbookFlagsEnum } from 'growthbook/types';
import { useFeatureIsOn } from '@growthbook/growthbook-react';
export const MaintenanceBanner = () => {
  const $ = _c(4);
  const {
    t
  } = useLocoTranslation();
  const maintenanceWorkIsOn = useFeatureIsOn(GrowthbookFlagsEnum.MaintenanceWork);
  if (!maintenanceWorkIsOn) {
    return null;
  }
  let t0;
  if ($[0] !== t) {
    t0 = t("global.info_section_title_maintenance_work");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <SectionMessage style="warn" textClassName="text-text-primary items-center" className="justify-center rounded-none border-r-0 border-l-0" iconClassName="w-5 h-5 hidden lg:block">{t0}</SectionMessage>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};